export default {
    divider: { flex: 1, flexDirection: "row" },
};
